import * as ui from './ui.selectors';

export { ui as uiSelectors };



// WEBPACK FOOTER //
// ./src/app/shared/store/selectors/index.ts